import {
  Button, Card, CardContent, CardHeader, CircularProgress,
  Divider, InputLabel, List, ListItem,
  ListItemSecondaryAction, ListItemText,
  TextField, Typography
} from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import SendIcon from '@material-ui/icons/Send';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useTranslation } from 'react-i18next';
import { connect, useSelector } from 'react-redux';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import { loadBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import Moment from 'moment';
import ErrorMessage from 'src/components/ErrorMessage';

const useStyles = makeStyles((theme) => ({
  root: {},
  dividerYorum: {
    backgroundColor: '#1D3343'
  },
  fieldsComboYorum: {
    margin: theme.spacing(0),
    display: 'flex',
  },
  content: {
    minHeight: 160,
  },
  submitButtonComment: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
}));

function Yorum({
  className, ReceiptNo, readonly, tasks
}) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const SessionUser = getUser();
  Moment.locale(SessionUser.TenantCode === 'my' ? 'en' : SessionUser.TenantCode);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [LoadingControl, setLoadingControl] = useState(false);
  const [YorumDetay, setYorumDetay] = React.useState([]);
  const YorumData = readonly ? tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)) : loadBaslandiJob();
  const [Kullanici, setKullanici] = useState([]);
  const [KullaniciId, setKullaniciId] = useState(0);
  const [Yorum, setYorum] = useState('');

  const [KararData, setKararData] = React.useState([]);
  const [valueKarar, setvalueKarar] = React.useState(0);
  const isOnline = useSelector((state) => state.status?.isOnline);

  const GetYorumKullanici = () => {
    axios.get(`/GetSiriusCommentUsers/${YorumData[0].ReceiptNo}/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}`)
      .then((response) => {
        if (response.data.length > 0) {
          setKullanici(response.data);
        }
      })
      .catch((error) => {

      });
  };
  useEffect(() => {
    GetYorumKullanici();
    // eslint-disable-next-line
  }, [YorumData[0].ReceiptNo, SessionUser.ServiceShopId, SessionUser.TechnicianId]);
  const handleChangeKullanici = (e) => {
    setKullaniciId(e.target.value);
  };
  const handleChangeYorum = (e) => {
    setYorum(e.target.value);
  };
  const handleYorumYap = () => {
    if (Yorum.length === 0) {
      setUyariTip('error');
      setUyariAciklama(t('yorum_yaziniz'));
      setUyari(true);
      return;
    }

    const data1 = {
      ServiceShopId: parseInt(YorumData[0].ServiceShopId) || 0,
      WorkOrderId: parseInt(YorumData[0].ReceiptNo) || 1,
      AnswerUser: parseInt(KullaniciId) || 0,
      Comment: Yorum || '',
      QuestionUser: parseInt(SessionUser.OrganizationUserId) || 1,
      Id: 1,
      Control: 3
    };


    const config1 = {
      headers: { 'Content-Type': 'application/json' }
    };
    setLoadingControl(true);
    axios.post('/SetSiriusWorkOrderChat', data1, config1)
      .then((response) => {
        setLoadingControl(false);
        const ResponseData1 = response.data;
        if (parseInt(ResponseData1.ErrorCode) !== 0) {
          setUyariTip('error');
          setUyariAciklama(ResponseData1.ErrorDescription);
        } else {
          setUyariTip('success');
          setUyariAciklama(ResponseData1.ErrorDescription);
          GetYorum();
        }
        setUyari(true);
      }).catch((error) => {
        setLoadingControl(false);
        setUyariTip('error');
        setUyariAciklama(t('Error') + error.message);
        setUyari(true);
      });
  };

  const setYorumSilEvet = (Id) => {
    const data = [{
      AppNr: YorumData[0].BASVURU_NO,
      ServiceShopId: YorumData[0].BIRIM_KODU,
      CommentRequested: 0,
      UserId: YorumData[0].TEKNISYEN_KODU,
      Comment: '',
      Operation: 0,
      CommentId: Id,
      Decision: 0,
    }];
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    setLoadingControl(true);
    axios.post('/SetArtemisComment', data, config)
      .then((response) => {
        setLoadingControl(false);
        const ResponseData = response.data;
        if (parseInt(ResponseData.ErrorCode) !== 0) {
          setUyariTip('error');
          setUyariAciklama(ResponseData.ErrorDescription);
        } else {
          setUyariTip('success');
          setUyariAciklama(ResponseData.ErrorDescription);
          GetYorum();
        }
        setUyari(true);
      }).catch((error) => {
        setLoadingControl(false);
        setUyariTip('error');
        setUyariAciklama(t('Error') + error.message);
        setUyari(true);
      });
  };

  const setYorumSil = (Id) => {
    confirmAlert({
      message: t('yorum_sil_confirm'),
      buttons: [
        {
          label: t('Evet'),
          onClick: () => setYorumSilEvet(Id)
        },
        {
          label: t('Hayir'),
          onClick: () => { }
        }
      ]
    });
  };


  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const GetYorum = () => {
    setLoadingControl(true);
    axios.get(`/GetSiriusChatWorkOrderDetail/${ReceiptNo}`)
      .then((response) => {
        const Deger = response.data;
        if (Deger.length === 0) {
          setYorumDetay([]);
        } else {
          setYorumDetay(Deger);
        }
        setLoadingControl(false);
      }).catch((error) => {
        setYorumDetay([]);
        setLoadingControl(false);
      });
  };

  useEffect(() => {
    GetYorum();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      // let cat = await getCategories();
      // setKararData(cat);
    };
    fetchCategories();
  }, []);

  return (
    <Card
      className={clsx(classes.root, className)}
    >
      <CardHeader title={t('Fis_Yorum')} />
      <Divider />
      {
        uyari
          ? <Alert onClose={uyariKapat} open={uyari} message={uyariAciklama || ''} variant={uyariTip} />
          : <div />
      }
      {isOnline ? (
        <CardContent>
          {LoadingControl
            ? (
              <CircularProgress
                status="loading"
                style={{ marginLeft: '50%' }}
              />
            )
            : ''}
          <Typography variant="h6" component="h2" gutterBottom>
            <FormControl variant="outlined" className={classes.fieldsComboYorum}>
              <InputLabel id="demo-comment-select-outlined-label" disabled={readonly}>{t('Kullanici')}</InputLabel>
              <Select
                native
                id="demo-comment-select-outlined"
                onChange={handleChangeKullanici}
                label={t('Kullanici')}
                fullWidth
                value={KullaniciId}
                labelId="kullanici_label"
                inputProps={{
                  name: 'kullanici_select',
                  id: 'kullanici_select'
                }}
              >
                <option value="0" defaultValue>{t('personel_secimi')}</option>
                {Kullanici.sort((a, b) => a.UserName.localeCompare(b.UserName)).map((p) => <option key={p.Id} value={p.Id}>{p.UserName}</option>)}
              </Select>
            </FormControl>
          </Typography>

          {/* <Typography variant="h6" component="h2" gutterBottom>
         <FormControl variant="outlined" className={classes.fieldsComboYorum}>
           <InputLabel disabled={readonly}>{t('Karar')}</InputLabel>
           <Select
             native
             value={valueKarar}
             onChange={(e) => setvalueKarar(e.target.value)}
             label={t('Karar')}
             fullWidth
           >
             <option value="0" defaultValue>{t('Kategori_seciniz_2')}</option>
             {KararData.filter(k => k.TIP === (SessionUser.ServiceShopId === 99 ? "BOLGE" : "SERVIS")).map(p => {
               return <option key={p.ID} value={p.ID}>{p.ACIKLAMA}</option>
             })}
           </Select>
         </FormControl>
       </Typography> */}

          <Typography variant="h6" component="h2" gutterBottom>
            <TextField
              label={t('Yorum_input')}
              name="Yorum"
              multiline
              rows={4}
              fullWidth
              value={Yorum}
              onChange={handleChangeYorum}
              variant="outlined"
              disabled={readonly}
            />
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={handleYorumYap}
            className={classes.submitButtonComment}
            endIcon={<SendIcon>Gonder</SendIcon>}
          >
            {t('Yorum_Gönder')}
          </Button>
        </CardContent>
      ) : (
        <CardContent>
          <ErrorMessage message={t('Offline_Message')} />
        </CardContent>
      )}
      <Divider className={classes.dividerYorum} />
      <CardContent className={classes.content}>
        <List className={classes.root}>
          {YorumDetay.map((log) => (
            <div key={log.Id}>
              <ListItem alignItems="flex-start">
                <ListItemText
                  primary=""
                  secondary={(
                    <>
                      <Typography
                        component="span"
                        variant="body1"
                        className={classes.inline}
                        color="textPrimary"
                      >
                        <b>
                          {t('Kullanici')}
                          :
                        </b>
                        {' '}
                        {log.QuestionUser}
                        <br />
                        <b>
                          {t('Tarih')}
                          :
                        </b>
                        {' '}
                        {log.QuestionDate === undefined ? '' : Moment(log.QuestionDate).format('DD/MM/YYYY HH:mm')}
                        <br />
                        <b>
                          {t('Mesaj')}
                          :
                        </b>
                        {' '}
                        {log.Question}
                        <br />
                        <b>
                          {t('Yanitlayan')}
                          :
                        </b>
                        {' '}
                        {log.AnswerUser}
                        <br />
                        <b>
                          {t('Yanit_Tarih')}
                          :
                        </b>
                        {' '}
                        {log.AnswerDate === undefined ? '' : Moment(log.AnswerDate).format('DD/MM/YYYY HH:mm')}
                        <br />
                        <b>
                          {t('Yanit')}
                          :
                        </b>
                        {' '}
                        {log.Answer}
                      </Typography>
                    </>
                  )}
                />
                {/* <ListItemSecondaryAction>
                  <RemoveCircleIcon onClick={() => setYorumSil(log.Id)} style={{ color: "red" }} />
                </ListItemSecondaryAction> */}
              </ListItem>
              <Divider className={classes.dividerYorum} />
            </div>
          ))}
        </List>
      </CardContent>
    </Card>
  );
}

Yorum.propTypes = {
  className: PropTypes.string,
};


export default connect(
  (state) => ({
    tasks: state.tasks1
  })
)(Yorum);
